<script setup>
import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { useForm, useField } from 'vee-validate'
import {
  KkTextField,
  KkValidationError,
  KkFormLabel,
} from '../../../../components/base'
import Select from '../../../../components/Select'
import KkInfo from '../../../ui/KkInfo/index.vue'
import imgTextPath from '../../../../../../images/mapion_biz/text.png'
import imgImagePath from '../../../../../../images/mapion_biz/image.png'
import imgUrlPath from '../../../../../../images/mapion_biz/url.png'
import imgBannerPath from '../../../../../../images/mapion_biz/banner.png'
import imgLinkPath from '../../../../../../images/mapion_biz/link.png'
import imgMovieIdPath from '../../../../../../images/mapion_biz/movie_id.png'
import imgIconPath from '../../../../../../images/mapion_biz/icon.png'
import imgAdTypePath from '../../../../../../images/mapion_biz/ad_type.png'
const { t } = useI18n()
const emit = defineEmits(['save', 'cancel'])
const state = reactive({
  kind: props.kind
})
const props = defineProps({
  kind: { type: String, default: '' },
  name: { type: String, default: '' },
  position: { type: String, required: true },
})
const schema = {
  name: 'max:100',
}
const { handleSubmit } = useForm({
  validationSchema: schema,
  initialValues: {
    name: props.name,
  },
})
const { value: name, errorMessage: nameError, handleChange: nameHandleChange } = useField('name', undefined, { label: t('pages.companies.mapionBizBannerTemplateForm.bannerLabel') })
const kindOptions = () => {
  const kinds = ['text', 'image', 'url', 'banner', 'link', 'movie_id', 'icon', 'ad_type']
  const results = {}
  kinds.forEach(kind => results[t(`pages.companies.mapionBizBannerTemplateForm.kind.${ kind }.label`)] = kind)
  return results
}
const save = handleSubmit((value) => {
  emit('save', { name: value.name, kind: state.kind }, props.position)
  state.kind = null
})
const cancel = () => {
  state.kind = null
  emit('cancel', props.position)
}
const imgPath = (kind) => {
  switch(kind) {
  case 'text':
    return imgTextPath
  case 'image':
    return imgImagePath
  case 'url':
    return imgUrlPath
  case 'banner':
    return imgBannerPath
  case 'link':
    return imgLinkPath
  case 'movie_id':
    return imgMovieIdPath
  case 'icon':
    return imgIconPath
  case 'ad_type':
    return imgAdTypePath
  default:
    return ''
  }
}
</script>
<template>
  <div class="p-box">
    <div class="p-box__body">
      <span class="fontBold">{{ $t("pages.companies.mapionBizBannerTemplateForm.selectLabel") }}</span>
      <Select v-model="state.kind" :options="kindOptions()" />
      <template v-if="state.kind">
        <div class="formHeader">
          <img :src="imgPath(state.kind)">
          <span>
            <KkInfo v-if="state.kind !== 'ad_type'" icon="hint">
              {{ $t(`pages.companies.mapionBizBannerTemplateForm.kind.${ state.kind }.info`) }}
            </KkInfo>
          </span>
        </div>
        <div class="formContainer">
          <KkFormLabel :text="`${ t('pages.companies.mapionBizBannerTemplateForm.bannerLabel') }(${ $t('labels.countCharacters', { count: name.length, max: 100 }) })${ t('labels.optionalLabel') }`" />
          <KkTextField :model-value="name" class="c-textField" :placeholder="$t('messages.noSettings')" @update:model-value="nameHandleChange" />
          <p>{{ $t(`pages.companies.mapionBizBannerTemplateForm.kind.${ state.kind }.example`) }}</p>
          <KkValidationError :text="nameError" />
        </div>
        <div class="c-button c-button--right">
          <button class="c-button__item c-button__item--outline-cancel" @click="cancel">
            {{ $t('labels.cancel') }}
          </button>
          <button
            class="c-button__item c-button__item--primary"
            @click="save"
          >
            {{ $t('labels.submitFilterCond') }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.formHeader {
  display: flex;
  margin: 15px 0;
  img {
    width: 30%;
    margin-right: 10px;
  }
}
.fontBold {
  font-weight: bold;
}
</style>
